import Phaser from 'phaser';
import { tr } from '../i18n';
import { DEPTH, UI } from './theme';
import { FocusNav, FocusItem } from './FocusNav';

const BTN = {
  fontSize: '24px',
  fontFamily: 'monospace',
  backgroundColor: '#1e2740',
  padding: { x: 24, y: 12 },
} as const;

/** 暂停覆盖层 + 两个按钮（继续 / 返回主菜单） */
export default class PauseMenu {
  private visible = false;
  private overlay: Phaser.GameObjects.Rectangle;
  private label: Phaser.GameObjects.Text;
  private resumeBtn: Phaser.GameObjects.Text;
  private menuBtn: Phaser.GameObjects.Text;
  private nav?: FocusNav;

  constructor(
    private readonly scene: Phaser.Scene,
    private readonly onResume: () => void,
    private readonly onQuit: () => void
  ) {
    const w = scene.scale.width;
    const h = scene.scale.height;

    this.overlay = scene.add
      .rectangle(0, 0, w, h, 0x000000, 0)
      .setOrigin(0)
      .setScrollFactor(0)
      .setDepth(DEPTH.pauseOverlay);

    this.label = scene.add
      .text(w / 2, h / 2 - 70, tr('pause.label'), {
        fontSize: '48px',
        fontFamily: 'monospace',
        color: UI.text,
      })
      .setOrigin(0.5)
      .setScrollFactor(0)
      .setDepth(DEPTH.pauseContent)
      .setVisible(false);

    this.resumeBtn = this.makeButton(w / 2, h / 2 + 10, tr('pause.resume'), UI.green, () =>
      this.onResume()
    );
    this.menuBtn = this.makeButton(w / 2, h / 2 + 75, tr('pause.menu'), UI.red, () => this.onQuit());
  }

  get isVisible() {
    return this.visible;
  }

  setVisible(v: boolean) {
    this.visible = v;
    this.overlay.setFillStyle(0x000000, v ? 0.6 : 0);
    this.label.setVisible(v);
    this.resumeBtn.setVisible(v);
    this.menuBtn.setVisible(v);

    if (v) {
      this.nav?.destroy();
      this.nav = new FocusNav(this.scene, 0, DEPTH.pauseNav);
      const items: FocusItem[] = [
        {
          row: 0, col: 0, target: this.resumeBtn,
          onSelect: () => this.onResume(),
          onFocus: () => this.resumeBtn.setColor('#a9ffce'),
          onBlur: () => this.resumeBtn.setColor(UI.green),
        },
        {
          row: 1, col: 0, target: this.menuBtn,
          onSelect: () => this.onQuit(),
          onFocus: () => this.menuBtn.setColor(UI.danger),
          onBlur: () => this.menuBtn.setColor(UI.red),
        },
      ];
      this.nav.setItems(items, 0);
    } else {
      this.nav?.destroy();
      this.nav = undefined;
    }
  }

  move(dx: number, dy: number) {
    this.nav?.move(dx, dy);
  }
  select() {
    this.nav?.select();
  }

  private makeButton(
    x: number,
    y: number,
    text: string,
    color: string,
    onDown: () => void
  ): Phaser.GameObjects.Text {
    const btn = this.scene.add
      .text(x, y, text, { ...BTN, color })
      .setOrigin(0.5)
      .setScrollFactor(0)
      .setDepth(DEPTH.pauseButton)
      .setVisible(false)
      .setInteractive({ useHandCursor: true });
    btn.on('pointerover', () => btn.setColor('#ffffff'));
    btn.on('pointerout', () => btn.setColor(color));
    btn.on('pointerdown', () => onDown());
    return btn;
  }
}
